import { useQuery } from "react-query";
import {
  fetchAllTerminals,
  fetchTerminalDetails,
  getInterwitchAccounts,
  getOpayMerchantIndustries,
  getTerminalBusinessAccount,
  getTerminalPaymentSession,
} from "../../../services/pos-terminals";

export const useGetTerminals = ({ queries = "", isEnabled = true }) => {
  return useQuery(
    ["fetchTerminals", queries],
    () => fetchAllTerminals(queries).then((res) => res?.data),
    {
      staleTime: Infinity,
      enabled: isEnabled,
    },
  );
};

export const useGetTerminalsDetails = ({ id }) => {
  return useQuery(
    ["getTerminalsDetails", `${id}`],
    () => fetchTerminalDetails(id).then((res) => res?.data?.data),
    {
      staleTime: Infinity,
    },
  );
};

export const useGetTerminalPaymentSession = ({
  transaction_id,
  terminal_id,
  paymentStatus = null,
  hitThirdParty = false,
  onSuccess = () => {},
}) => {
  return useQuery(
    ["getTerminalPaymentSession", `${terminal_id}`, `${transaction_id}`],
    () =>
      getTerminalPaymentSession({
        terminal_id,
        transaction_id,
        hitThirdParty,
      }).then((res) => res.data?.data),
    {
      enabled: transaction_id ? true : false,
      staleTime:
        paymentStatus === "PENDING" || paymentStatus === "PROCESSING"
          ? 5000
          : Infinity,
      refetchInterval:
        paymentStatus === "PENDING" || paymentStatus === "PROCESSING"
          ? 5000
          : Infinity,
      onSettled: () => onSuccess(),
    },
  );
};

export const useGetInterwitchAccounts = ({
  queries = "",
  isEnabled = true,
}) => {
  return useQuery(
    ["getInterwitchAccount", queries],
    () => getInterwitchAccounts().then((res) => res?.data),
    {
      staleTime: Infinity,
      enabled: isEnabled,
    },
  );
};

export const useGetTerminalBusinessAccount = ({ path, queryKey = "" }) => {
  return useQuery(
    [queryKey],
    () => getTerminalBusinessAccount(path).then((res) => res?.data?.data),
    {
      staleTime: Infinity,
      enabled: path ? true : false,
    },
  );
};

export const useGetOpayMerchantIndustries = ({ isEnabled }) => {
  return useQuery(
    ["getOpayMerchantIndustries"],
    () => getOpayMerchantIndustries().then((res) => res?.data?.data),
    {
      staleTime: Infinity,
      enabled: isEnabled,
    },
  );
};
